import { IconProps } from './types';

const Exit = ({ className, strokeWidth }: IconProps) => {
    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
            strokeWidth={strokeWidth}
        >
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M20 5 5 20M20 20 5 5"
            />
        </svg>
    );
};

export default Exit;
